<template>
  <kst-section class="mt-5" :title="deliverySectionTitle">
    <kst-warning class="mb-4" :items="deliveryWarning"/>

    <kst-input field="IsNeedDelivery" :data="userData" :catalog="Catalog"
      @input="handleDelivery_Change"
    />
    <template v-if="userData.IsNeedDelivery">
      <kst-input field="DeliveryDate" :data="userData" :catalog="Catalog"
        :customValidations="deliveryDateValidations"
      />
    </template>
  </kst-section>
</template>

<script>
import Catalog from "../InvoiceCatalog.js";
import Info from "../InvoiceInfo.js";
import Model from "../InvoiceModel.js";

export default {
  props: {
    userData: Object
  },
  data: () => ({
    Catalog: Catalog
  }),
  computed: {
    deliveryDateValidations() {
      return Model.validationDeliveryDate(this.userData);
    },
    deliverySectionTitle() {
      return Info.Section.Delivery.Title;
    },
    deliveryWarning() {
      return [
        Info.Message.New_IsNeedDelivery,
        Info.Message.New_InvoiceStatus,
      ];
    }
  },
  methods: {
    handleDelivery_Change() {
      Model.updateDetailsByDelivery(this.userData);
    }
  }
}
</script>